const shapeQuizResponseData = (responseData = []) => {
  const sanitizedData = responseData.map((data) => {
    return {
      quizId: data.quiz_id,
      answerId: data.answer_id,
      isCorrect: data.answer_is_correct,
    };
  });

  return sanitizedData;
};

export default shapeQuizResponseData;
